<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div class="db-card">
                        <flash-message autoHide variant="success"></flash-message>
                        <div class="row justify-content-lg-center justify-content-xl-center">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                <div class="row">
                                    <div class="col-12 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                                        <div class="circle">
                                            <label class="initials">{{ initialAvatar(firstName, lastName) }}</label>
                                        </div>
                                        <div class="db-mentee-name">{{ firstName + ' ' + lastName }}</div>
                                        <div class="db-mentor-name">Mentor: <span>{{ mentorName.join(', ') }}</span></div>
                                    </div>
                                    <div class="col-12 col-sm-3 col-md-3 col-lg-2 col-xl-3">
                                        <button 
                                            v-if="(account_user_status == 'Active')"  
                                            @click="doUpdateMenteeStatus('Inactivate')"
                                            class="btn btn-primary btn-sm statusBtn">
                                            Inactivate
                                        </button>
                                        <!--<button 
                                            v-if="(status === false && countStatusLog > 0)"
                                            @click="doUpdateMenteeStatus('Activate')"
                                            class="btn btn-primary btn-sm statusBtn">
                                            Re-Activate
                                        </button>-->
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Status: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ userTypeName }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Email Address: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ email }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Phone Number: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ phoneNo }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row" v-if="compensation > 0 && isManager">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Compensation: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_val">{{ '$' + compensation + '/hr' }}</div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Assign Task List(s)<span class="required">*</span>: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="custom-control custom-checkbox" v-for="(taskList, tindex) in taskLists" :key="tindex">
                                            <input 
                                                type="checkbox" 
                                                class="custom-control-input" 
                                                name="Assign Task List"
                                                :id="'assign_task_list_' + tindex"
                                                v-validate="'required'"
                                                :value="taskList.id"
                                                :checked="taskList.checked"
                                                v-model="tasks_selected"
                                                @click="getTasklistSelected(taskList, $event)">
                                            <label class="custom-control-label" :for="'assign_task_list_' + tindex">{{ taskList.name }}</label>
                                        </div>
                                        <div v-show="verrors.has('Assign Task List')" class="validate-warning-msg">{{ verrors.first('Assign Task List') }}</div>
                                    </div>
                                </div>
                                 
                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Privileges: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="custom-control custom-checkbox" v-for="(privilege, pindex) in privileges" :key="pindex">
                                            <input 
                                                type="checkbox" 
                                                class="custom-control-input" 
                                                name="Privileges"
                                                :id="'privileges_' + pindex"
                                                :value="privilege.id"
                                                :checked="privilege.checked"
                                                v-model="privileges_selected"
                                                @click="getPrivilegesSelected($event)">
                                            <label class="custom-control-label" :for="'privileges_' + pindex">{{ privilege.name }}</label>
                                        </div>


                                    </div>






                                </div>

                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Assign Courses: </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="custom-control custom-checkbox" v-for="(course, cindex) in courses" :key="cindex">
                                            <input 
                                                type="checkbox" 
                                                class="custom-control-input" 
                                                name="Assign Course"
                                                :id="'assign_course_' + cindex"
                                                :value="course.id"
                                                v-model="courseSelected"
                                                :checked="course.checked"
                                @click="getCourseSelected(option, $event)">
                                            <label class="custom-control-label" :for="'assign_course_' + cindex">{{ course.name }}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Mentor(s):</div>
                                    </div>
                                    <div class="col-11 col-sm-11 col-md-11 col-lg-6 col-xl-6 cols">
                                        <div class="search-padd" id="mentor-group-wrapper">
                                            <multiselect v-model="mentor_assigned"
                                                :options="mentorOptions"
                                                track-by="value"
                                                label="text"
                                                placeholder="Select Mentor(s)"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :show-labels="false"
                                                v-bind:name="'mentor_assigned[]'"
                                                v-bind:id="'mentor_assigned'"
                                                v-validate="'required'"
                                                @select="toggleSelected($event)"
                                                @remove="toggleRemoved($event)">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ getMentorDisplayText(values.length) }}</span></template>
                                            </multiselect>
                                            <div v-if="verrors.firstByRule('mentor_assigned[]', 'required')" class="margin-bottom-5 validate-warning-msg">Mentor(s) is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">User Type: <span class="required">*</span></div>
                                    </div>
                                    <div class="col-11 col-sm-11 col-md-11 col-lg-6 col-xl-6 cols">
                                        <div class="search-padd">
                                            <select 
                                            class="custom-select" 
                                            id="user_type" 
                                            name="user_type"
                                            v-model="user_type"
                                            v-validate="'required'">
                                            <option v-for="(item, index) in usertype_options" :key="index" :value="item.value">{{ item.text }}</option>
                                            </select>
                                            <div v-if="verrors.firstByRule('user_type', 'required')" class="margin-bottom-5 validate-warning-msg">User Type is required</div>
                                        </div>
                                    </div>
                                </div>

      <div class="row grid_row" v-if="assessments.length > 0">
          <div class="col-12 col-sm-12 cols">
            <div class="label_txt">Assign Assessments:</div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                <div class="custom-control custom-checkbox" v-for="(option, index) in assessments" :key="index">
                <input 
                  name="Assessment assigned"
                  :value="option.id" 
                  :id="'assessment_' + index" 
                  type="checkbox" 
                  :checked="option.checked"
                  v-model="assessmentSelected"
                  class="custom-control-input"
                  @click="getAssessmentSelected(option, $event)"
                  >
                <label class="custom-control-label" :for="'assessment_' + index">{{ option.name }}</label>
              </div>
            </div>
         </div>
        </div>


                                <div class="row grid_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols">
                                        <div class="label_txt">Settings: </div>
                                    </div>
                                        <div class="custom-control custom-checkbox" v-for="(submit_comment, csindex) in submit_comments" key="2">
                                            <input 
                                                type="checkbox" 
                                                class="custom-control-input" 
                                                name="submit_comment"
                                                :id="'submit_comment_' + csindex"
                                                :value="submit_comment.id"
                                                :checked="submit_comment.checked"
                                                v-model="submit_comments_selected"
                                                @click="getSubmitCommentsSelected($event)">
                                            <label class="custom-control-label" :for="'submit_comment_' + csindex">{{ submit_comment.name }}</label>
                                        </div>

                                    </div>





                                <div class="text-center mt-4">
                                    <button type="submit" class="btn btn-sm btn-blue text-center saveBtn" @click="doUpdateMentee()">Save Changes</button>
                                </div>







                            </div>
                        </div>
                        <EditMenteeAccountStatus
                            :isModalVisible="isMenteeAccountStatusModalVisible"
                            ref="mentee_account_status_modal"
                            @close="isMenteeAccountStatusModalVisible = false">
                        </EditMenteeAccountStatus>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';
import EditMenteeAccountStatus from "./edit_mentee_account_status.vue";

import Multiselect from 'vue-multiselect';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
export default {
    data(){
        return{
            isMenteeAccountStatusModalVisible: false,
            statusType: '',
            tasks_selected: [],
            privileges_selected: [],
            taskLists: [],
            tasklistSelected: [],
            menteeTasklist: [],
            firstName: '',
            lastName: '',
            email: '',
            phoneNo: '',
            status: '',
            account_user_status: '',
            countStatusLog: 0,
            compensation: '',
            isManager: false,
            mentorName: [],
            user_roles: [],
            courses: [],
            privileges: [
            {
                'id': 1,
                'name': 'can submit reps for review',
                'checked': false,
            },
            ],
            submit_comments_selected: [],
            submit_comments: [
            {
                'id': 1,
                'name': 'Enable comments',
                'checked': false,
            },
            ],
            mentorOptions: [],
            mentor_assigned: [],
            assessments: [],
            assessmentSelected: [],
            menteeCourses: [],
            courseSelected: [],
            usertype_options: [
                {value: '', text: 'Select User Type'},
                {value: 'mentee', text: 'Mentee'},
            ],
            user_type: '',
            program: 'Mentorship',
            userTypeName: '',
        }
    },
    methods:{
        initialAvatar(firstname, lastname) {
          var initial = '';
          initial = firstname.charAt(0) + lastname.charAt(0);
          return initial.toUpperCase();
        },
      getAssessmentSelected(assessment, event) {
        if(event.value == true) {
           this.assessmentSelected.push(assessment.id);
        }
        else {
            const removeItem = assessment.id;
            const removeItemIndex = this.assessmentSelected.indexOf(removeItem);
            if(removeItemIndex > -1) {
              this.assessmentSelected.splice(removeItemIndex, 1); 
            }
        }
      },
        getTasklistSelected(taskList, event) {        
            if(event.value == true) {
                this.tasklistSelected.push(taskList.id);
            }
            else {
                const removeItem = taskList.id;
                const removeItemIndex = this.tasklistSelected.indexOf(removeItem);
                this.tasklistSelected.splice(removeItemIndex, 1); 
            }
            //console.log(this.tasklistSelected)
        },
        getPrivilegesSelected(event) {        
            if(event.value == true) {
                this.privileges[0].checked = true;
            }
            else {
                this.privileges[0].checked = false;
            }
        },
        getSubmitCommentsSelected(event) {        
            if(event.value == true) {
                this.submit_comments[0].checked = true;
            }
            else {
                this.submit_comments[0].checked = false;
            }
        },

        doUpdateMenteeStatus(type) {
            this.isMenteeAccountStatusModalVisible = true;
            this.$refs.mentee_account_status_modal.getItem(type);
        },
        IsUserManager() {
              var roles = this.$store.state.roles;
              if(roles.indexOf('ROLE_ADMIN') > -1)
              {
                return true;
              }
              else {
                if (this.$store.state.switch_admin_roles && this.$store.state.switch_admin_roles.indexOf("ROLE_ADMIN") > -1) {
                    return true;
                } else {
                    return false;
                }
              }
        },
        doUpdateMentee() {
            const menteeId = this.$route.params.mentee_id;
            this.$validator.validateAll().then((result) => {
                if(!result) {
                    return;
                }
                axios('/desktop/mentee-profile-edit',
                {
                    method: 'POST',
                    data: {
                    "mentee_id" : menteeId,
                    "tasklists_assigned": this.tasks_selected,
                    "privileges": this.privileges_selected,
                    "submit_comments": this.submit_comments_selected,
                    "mentor_assigned": this.mentor_assigned,
                    "assessments_assigned": this.assessmentSelected,
                    "courses_assigned": this.courseSelected,
                    "user_type": this.user_type,
                    "account_id": this.$store.state.user_accountid
                    }
                },
                )
                .then(()=> {
                    this.flash({ message: 'Profile updated successfully', variant: 'success' });
                    this.$router.push(this.$router.currentRoute.path)
                    this.$router.go();
                })
                .catch(() => {
                });
            }).catch(() => {
                // catches the error;
            });
        },
        getMentorDisplayText(count) {
            if (count == 1) {
                return this.mentorName[0];
            } else {
                var num = (count - 1);
                if (count > 2) {
                    var otherText = num + " Others";
                } else {
                    var otherText = num + " Other";
                }
                return this.mentorName[0] + ", +" + otherText;
            }
        },
        toggleSelected(item) {
            this.mentorName.push(item.text);
        },
        toggleRemoved(item) {
            if(this.mentorName.indexOf(item.text) > -1) {
                const removeItemIndex = this.mentorName.indexOf(item.text);
                this.mentorName.splice(removeItemIndex, 1); 
            }
        },
        getCourseSelected(course, event) {
            if(event.value == true) {
               this.courseSelected.push(course.id);
            }
            else {
                const removeItem = course.id;
                const removeItemIndex = this.courseSelected.indexOf(removeItem);
                if(removeItemIndex > -1) {
                  this.courseSelected.splice(removeItemIndex, 1); 
                }
            }
        },
    },
    components: {
        UserMenu,
        GoBack,
        AdminSidebarMenu,
        EditMenteeAccountStatus,
        Multiselect,
    },
    created() {
        const menteeId = this.$route.params.mentee_id;
        this.isManager = this.IsUserManager();

        axios('/desktop/user-account-info/' + menteeId+'/'+this.$store.state.user_accountid,
        {
            method: 'GET',
        })
        .then(response => {
            this.program = response.data.program;
            if (this.program == 'Apprenticeship') {
                this.usertype_options = [];
                this.usertype_options = [
                    {value: '', text: 'Select User Type'},
                    {value: 'apprentice', text: 'Apprentice'},
                ];
            } else if (this.program == 'Mentorship & Apprenticeship') {
                this.usertype_options.push({value: 'apprentice', text: 'Apprentice'});
            }
        })
        .catch(() => {
        });
        axios.get('/alltasklists-account', {      
            params: {
                account_id: this.$store.state.user_accountid,
            }  
        })
        .then(response =>  {
          this.taskLists = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
        setTimeout(()=>{
        axios.get('/desktop/mentee-details/' + menteeId + '/' + this.$store.state.user_accountid, {
       
        })
        .then(response =>  {
          this.firstName = response.data.mentee_first_name;
          this.lastName = response.data.mentee_last_name;
          this.email = response.data.mentee_email;
          this.phoneNo = response.data.mentee_phone_no;
          this.status = response.data.mentee_status;
          this.account_user_status = response.data.mentee_account_status;
          this.goals = response.data.mentee_goals;
          this.menteeTasklist = response.data.mentee_tasklist;
          this.compensation = response.data.compensation;
          this.menteeAssessment = response.data.mentee_assessment;
          this.menteeCourses = response.data.mentee_courses;
          this.user_type = response.data.user_type;
          this.privileges[0].checked = response.data.privileges;
          this.submit_comments[0].checked = response.data.submit_comments;
          if (this.privileges[0].checked === true) {
              this.privileges_selected.push(this.privileges[0].id)
          }
          if (this.submit_comments[0].checked === true) {
              this.submit_comments_selected.push(this.submit_comments[0].id)
          }
          for(var i=0; i < response.data.groups.length; i++) {
            this.mentorName.push(response.data.groups[i].name);
            var group = {value: response.data.groups[i].id, text: response.data.groups[i].groupName};
            this.mentor_assigned.push(group);
          }
          this.countStatusLog = response.data.count_mentee_status_log[1];          
          
          for( i=0; i<this.taskLists.length; i++) {
            if(this.menteeTasklist.indexOf(this.taskLists[i].id) > -1) {
              this.taskLists[i].checked = true;
              this.tasks_selected.push(this.taskLists[i].id);
            }
            else {
              this.taskLists[i].checked = false;
            }
          }
          
        var userTypeName = "Mentee";
        var userRole = "ROLE_MENTEE";
        if (this.user_type == 'apprentice') {
            userRole = "ROLE_APPRENTICE";
            userTypeName = "Apprentice";
        }
        if (this.account_user_status == 'Active') {
            this.userTypeName = userTypeName + ' - Active';
        } else {
            this.userTypeName = userTypeName + ' - Inactive';
        } 

        axios.get('/desktop/assessment-builder-lists', {
            params: {
                user_roles: userRole,
                accountId: this.$store.state.user_accountid
            }
        })
        .then(response =>  {
            this.assessments = response.data;            
            for( i=0; i<this.assessments.length; i++) {
                if(this.menteeAssessment.indexOf(this.assessments[i].id) > -1) {
                    this.assessments[i].checked = true;
                    this.assessmentSelected.push(this.assessments[i].id);
                }
                else {
                    this.assessments[i].checked = false;
                }
            }
        })
        .catch(function(error) {
            console.log(error);
        });

        axios.get('/desktop/course-lists', {
            params: {
                user_roles: userRole,
                accountId: this.$store.state.user_accountid
            }
        })
        .then(response =>  {
            this.courses = response.data;
            for( i=0; i<this.courses.length; i++) {
                if(this.menteeCourses.indexOf(this.courses[i].id) > -1) {
                    this.courses[i].checked = true;
                    this.courseSelected.push(this.courses[i].id);
                }
                else {
                    this.courses[i].checked = false;
                }
            }
        })
        .catch(function(error) {
            console.log(error);
        });

        })
        .catch(function(error) {
          console.log(error);
        });
        }, 1500);
    },
    mounted() {

        axios('/accountgroups',
            {
                method: 'GET',
                params: {
                    account_id: this.$store.state.user_accountid,
                }
            },
        )
        .then(response => {
            for(var i=0; i < response.data.length; i++) {
                var group = {value: response.data[i].id, text: response.data[i].groupName};
                this.mentorOptions.push(group);
            }

            //console.log(this.mentorOptions)
        })
        .catch(error => {

        });
    }
}
</script>
<style scoped>
.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
  margin-top: 10px;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 10px;
  margin-left: 10px;
}
.grid_row .cols { padding: 0; }
.db-card .label_txt {
  font-weight: 900;
  margin-bottom: 5px;
}
.circle {
  background-color: #A5A5A5;
  border-radius: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-right: 5px;
  float: left;
}
.initials {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  position: relative;
  transform: translateY(22px);
  color: #FFF;
  display: inline-block;
  vertical-align: middle;
}
.statusBtn, .statusBtn:active, .statusBtn:focus {
  float: right;
  color: #ba0d20 !important;
  background-color: #FFF !important;
  border: 2px solid #ba0d20 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 8px;
  line-height: 8px;
  margin: 20px 0;
  width: 140px;
}
.statusBtn:focus {
  box-shadow: none !important;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}
</style>
<style>
#mentor-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentor-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect__tags, .multiselect__input, .multiselect__single {
    background-color: #e1e1e1 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/manager/manage_mentee_profile.vue